import React from "react";
import { connect } from "react-redux";
import BackButton from "./BackButton";
import ToggleButton from "./ToggleButton";
import $ from "jquery";
import Modal from "./Modal";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import pencil from "assets/img/pencil.svg";
import close from "assets/img/close.svg";
import API from "@aws-amplify/api";
import "assets/scss/styles.css";
import Parser from "html-react-parser";

let apiName = process.env.REACT_APP_AMPLIFY_API;

class AddRule extends React.Component {
  constructor(props) {
    super(props);
  }

  deleteRuleClick(selectedRule) {
    this.props.dispatch({
      type: "TILL_SQL_POP_SEGMENT",
      selectedIndex: this.props.index,
      selectedRule: selectedRule
    });
    this.props.dispatch({ type: "Add_SEGMENT" });
  }
  getWhereCondition() {
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let groupLeveltoggle = this.props.groupLeveltoggle;
    let ruleLeveltoggle = this.props.ruleLeveltoggle;
    let count = 0;
    let sqlAndOrOperator = "";
    this.props.tillSqlSelectionArr.map((resultData, index) => {
      selectedRule += `(`;
      resultData.map((options, key) => {
        let length = options.length;
        if ('value' in  options[length - 2] && options[length - 2].value.includes("+++")) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (options[length - 1].value === 'BETWEEN' || options[length - 1].value === 'NOT BETWEEN') {
          selectedRule += "("
        }
        selectedRule +=
          "(" + options[length - 2].value + " " + options[length - 1].value;
        let data = this.props.afterSqlSelectionArr[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (typeof num == 'string') {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `) AND cac_addr_state='IN')`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                if (typeof num == 'string') {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
              }
            } else {
              let num = result.value;
              if (options[length - 1].value === 'BETWEEN' || options[length - 1].value === 'NOT BETWEEN') {
                selectedRule += ` ${result.value}) AND cac_addr_state='IN'),`;
              } else if (typeof num == 'string') {
                selectedRule += ` '${result.value}' AND cac_addr_state='IN'), `;
              } else {
                selectedRule += ` ${result.value}  AND cac_addr_state='IN'), `;
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
              }
            }
          });
        }
      });
      selectedRule += `)`;
      sqlAndOrOperator = "";
      if (
        groupLeveltoggle.length > 0 &&
        this.props.tillSqlSelectionArr.length - 1 != index &&
        groupLeveltoggle[0] != undefined &&
        groupLeveltoggle[0][index] != undefined
      ) {
        sqlAndOrOperator = groupLeveltoggle[0][index];
        selectedRule += ` ${sqlAndOrOperator} `;
      }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
    });
    return selectedRule;
  }
  displayQuery() {
    this.props.dispatch({
      type: "UPDATE_QUERY_COUNT_SEGMENT",
      segmentData: []
    });
    this.props.dispatch({
      type: "SHOW_SPINNER_SEGMENT",
      payload: ""
    });

    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let groupLeveltoggle = this.props.groupLeveltoggleSegment;
    let ruleLeveltoggle = this.props.ruleLeveltoggleSegment;
    let count = 0;
    let sqlAndOrOperator = "";
    this.props.tillSqlSelectionArrSegment.map((resultData, index) => {
      let segment = "";
      if (this.props.segmentName[index] != undefined) {
        segment = this.props.segmentName[index];
      }
      selectedRule += `WHEN `;
      resultData.map((options, key) => {
        let length = options.length;
        if ('value' in  options[length - 2] && options[length - 2].value.includes("+++")) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (options[length - 1].value === 'BETWEEN' || options[length - 1].value === 'NOT BETWEEN') {
          selectedRule += "("
        }
        if(options[length - 1].value === 'cardinality(array_intersect(' || options[length - 1].value === 'cardinality(array_except('){
          selectedRule +=
          "(" + options[length - 1].value + options[length - 2].value + ", array";
        }
        else{
          selectedRule +=
          "(" + options[length - 2].value + " " + options[length - 1].value;
        }
        let data = this.props.afterSqlSelectionArrSegment[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (typeof num == 'string') {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `))`;
                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                if (typeof num == 'string') {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
              }
            } 
            
            else if (
              options[length - 1].value == "cardinality(array_intersect(" 
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = []
                selectedRule += ` '${result.value}', `;
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `])) > 0 AND cac_addr_state='IN')`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
              }
            } 


            else if (
              options[length - 1].value == "cardinality(array_except(" 
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = []
                selectedRule += ` '${result.value}', `;
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `])) > 0 AND cac_addr_state='IN')`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
              }
            } 
            
            
            else {
              let num = result.value;
              if (options[length - 1].value === 'BETWEEN' || options[length - 1].value === 'NOT BETWEEN') {
                selectedRule += ` ${result.value}) AND cac_addr_state='IN'),`;
              } else if (typeof num == 'string') {
                selectedRule += ` '${result.value}'), `;
              } else {
                selectedRule += ` ${result.value}), `;
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
              }
            }
          });
        }
      });
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      selectedRule += ` THEN `;
      selectedRule += ` '${segment}' `;
      // selectedRule += `)`;
      // sqlAndOrOperator = "";
      // if (
      //   groupLeveltoggle.length > 0 &&
      //   this.props.tillSqlSelectionArrSegment.length - 1 != index &&
      //   groupLeveltoggle[0] != undefined &&
      //   groupLeveltoggle[0][index] != undefined
      // ) {
      //   sqlAndOrOperator = groupLeveltoggle[0][index];
      //   selectedRule += ` ${sqlAndOrOperator} `;
      // }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
    });
    let where = this.getWhereCondition();
    let fQS = ";";
    if (where == "") {
      fQS =
        "SELECT segment, count(*) as count from (SELECT CASE " +
        selectedRule +
        "ELSE 'Remainder' END AS segment FROM " + process.env.REACT_APP_ATHENA_TABLE + " WHERE cac_addr_state='IN' ) GROUP BY segment";
    } else {
      fQS =
        "SELECT segment, count(*) as count from (SELECT CASE " +
        selectedRule +
        "ELSE 'Remainder' END AS segment FROM " + process.env.REACT_APP_ATHENA_TABLE + " WHERE " +
        where +
        ") GROUP BY segment";
    }
    let myInitCount = {
      headers: {},
      body: {
        sql: fQS,
        isSegment: true
      }
    };
    if (this.props.summaryDetails['segments_tab_details']['condition'] === "" || this.props.summaryDetails['segments_tab_details']['condition'] !== fQS) {
      API.post(apiName, "/counts", myInitCount)
      .then(response => {
        this.props.dispatch({ type: "UPDATE_SUMMARY_DETAILS", segmentsTabPayload: fQS, segmentsTabValue: response["final_result"]["Items"]});
        this.props.dispatch({
          type: "UPDATE_QUERY_COUNT_SEGMENT",
          segmentData: response["final_result"]["Items"]
        });
      })
      .catch(error => {
      });
    } else {
      if (this.props.summaryDetails['segments_tab_details']['value'] !== undefined) {
        this.props.dispatch({
          type: "UPDATE_QUERY_COUNT_SEGMENT",
          segmentData: this.props.summaryDetails['segments_tab_details']['value']
        });
      } else {
        API.post(apiName, "/counts", myInitCount)
        .then(response => {
          this.props.dispatch({ type: "UPDATE_SUMMARY_DETAILS", segmentsTabPayload: fQS, segmentsTabValue: response["final_result"]["Items"]});
          this.props.dispatch({
            type: "UPDATE_QUERY_COUNT_SEGMENT",
            segmentData: response["final_result"]["Items"]
          });
        })
        .catch(error => {
        });
      }
    }
  }

  fetchQueryData() {

  }

  render() {
    if (this.props.index === 0) {
      this.displayQuery();
    }
    const { classes } = this.props;
    let tillSqlSelectionArr = this.props.selectedValue;
    let afterSqlSelectionArr = this.props.afterSqlSelectionArrSegment[
      this.props.index
    ];
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    tillSqlSelectionArr.map((options, key) => {
      let length = options.length;
      selectedRule =
        "<strong>" +
        options[length - 2].label +
        "</strong> " +
        options[length - 1].label +
        " ";
      let data = afterSqlSelectionArr[key];
      if (data.length > 0) {
        data.map((result, key) => {
          if (
            options[length - 1].value == "IN" ||
            options[length - 1].value == "NOT IN"
          ) {
            if (key == 0) {
              selectedRule += ``;
            }
            selectedRule += `<strong> ${result.label} </strong>, `;
            if (key == data.length - 1) {
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              selectedRule += ``;
            }
          } else {
            if (result.label == "number_field_name" || result.label == "string_field_name") {
              selectedRule += `<strong> ${result.value} <strong>, `;
            } else {
              selectedRule += `<strong> ${result.label} <strong>, `;
            }
          }
        });
      }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      selectedResult.push(selectedRule);
    });
    let htmlContent = selectedResult.map((options, key) => (
      <li key={key}>
        <a
          href="javascript:void(0)"
          className="borderbtn"
          dangerouslySetInnerHTML={{ __html: options }}
        />
        <div className="editandclosespace">
          <Button
            style={{ textAlign: "center" }}
            className="btn btncreate editableicon"
            color="danger"
            onClick={() => this.deleteRuleClick(key)}
          >
            <i className="fa fa-trash" />
          </Button>
          <Modal
            titleName="Edit Rule"
            buttonLabel="Edit"
            selectedIndex={this.props.index}
            selectedRule={key}
            mode="Edit"
            type="rule"
            buttonType="edit button"
            class="editableicon"
          />
        </div>
        {selectedResult.length > 0 && selectedResult.length - 1 != key ? (
          <div
            className="andorbtngroupwrap"
            // <div className="andorbtngroupwrap parentwrap"
            //  style={{left: "-65px", marginTop:"10px", bottom:"-38px"}}
          >
            <div className="andorgroup">
              <ToggleButton
                selectedIndex={this.props.index}
                selectedRule={key}
                type="Rule"
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </li>
    ));
    return (
      <React.Fragment>
        {/* <ul className="addrulelisting"> */}
        <ul
          className={
            htmlContent.length === 1 ? "addrulelisting-c" : "addrulelisting"
          }
        >
          {htmlContent}
        </ul>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  countSegment: state.countSegment,
  tillSqlSelectionArrSegment: state.tillSqlSelectionArrSegment,
  afterSqlSelectionArrSegment: state.afterSqlSelectionArrSegment,
  ruleLeveltoggleSegment: state.ruleLeveltoggleSegment,
  groupLeveltoggleSegment: state.groupLeveltoggleSegment,
  segmentName: state.segmentName,

  count: state.count,
  tillSqlSelectionArr: state.tillSqlSelectionArr,
  afterSqlSelectionArr: state.afterSqlSelectionArr,
  ruleLeveltoggle: state.ruleLeveltoggle,
  groupLeveltoggle: state.groupLeveltoggle,
  summaryDetails: state.summaryDetails
});

export default connect(mapStateToProps)(
  withStyles(notificationsStyle)(AddRule)
);



// WEBPACK FOOTER //
// ./src/views/Audiences/SegmentQueryBuilder/AddRule.jsx